__turbopack_context__.v({
  "darkBackground": "DropdownContents-module__cYrefG__darkBackground",
  "dropdownContent": "DropdownContents-module__cYrefG__dropdownContent",
  "dropdownContentContainer": "DropdownContents-module__cYrefG__dropdownContentContainer",
});
